/*** Navigation ***/

var $toggle = $( ".js-menu-toggle" );
var $menu = $( ".js-menu" );
var $header = $( ".header" );
var width = $(window).width();
var windowHeight = '';
var calloutHeight = '';
var headerMainHeight = '';
// var collapse = $(".menu-item-has-children");

function showNav() {
  $(".js-menu").addClass('nav-open');
  $("body").addClass('nav-open');
  window.setTimeout(function(){$('body').addClass('no_scroll');}, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done
  $('.nav--main a').attr('tabindex', ''); // links inside navigation should be TAB selectable
  // if (width < 980) {
  windowHeight = $(window).height();
  calloutHeight = ($('#header--callout').css('display') == 'none') ? 0 : $('#header--callout').outerHeight();
  headerMainHeight = $('#header--main').outerHeight();
  $('#header--main-extended').height(windowHeight - calloutHeight - headerMainHeight);
  // }
}

function hideNav() {
  $(".js-menu").removeClass('nav-open');
  $("body").removeClass('nav-open');
  window.setTimeout(function(){$('body').removeClass('no_scroll');}, 10); // allow animations to start before removing class (Firefox)
  $('.nav--main a').attr('tabindex', '-1'); // links inside hidden navigation should not be TAB selectable
  // if (width < 980) {
  $('#header--main-extended').height(0);
  // }
}

function showHideNav() {
  if ($(".js-menu").hasClass('nav-open')) {
    hideNav();
  } else {
    showNav();
  }
}

// shows/hides navigation’s popover if class "expanded"
$('.js-menu-toggle').on('click touchstart', function(event) {
  if (event.cancelable) event.preventDefault();
  showHideNav();
});

$('body').keydown(function(e) {
  // menu accessible via TAB as well
  if ($(".js-menu-toggle").is(":focus")) {
    // if ENTER/SPACE show/hide menu
    if (e.keyCode === 13 || e.keyCode === 32) {
      showHideNav();
      e.preventDefault();
    }
  }

  // if ESC show/hide menu
  if (e.keyCode === 27 || e.keyCode === 27) {
    showHideNav();
    e.preventDefault();
  }
});

// Dropdown functionality
$(".menu-item-has-children > a").on('click', function (event) {
  if (width < 980) {
    event.preventDefault();
    $(this).parent().siblings().not(".tickets").removeClass("collapsed");
    $(this).parent().toggleClass("collapsed");
    if ($(this).parent().hasClass("collapsed")) {
      $(this).parent().siblings().not(".tickets").addClass("unfocused");
    } else {
      $(this).parent().siblings().not(".tickets").removeClass("unfocused");
    }
    if ($(this).parent().hasClass("unfocused")) {
      $(this).parent().removeClass("unfocused");
    }
  }
});

$(".menu-item-has-children a").click(function(event){
  event.stopPropagation();
});
